var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"outlined":"","flat":"","hide-details":"auto","item-text":"label","item-value":"value","items":_vm.items,"label":_vm.fieldLabel,"rules":_vm.rules,"menu-props":{ bottom: true, offsetY: true }},model:{value:(_vm.fieldValue),callback:function ($$v) {_vm.fieldValue=$$v},expression:"fieldValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }